import SMFindMerchant from '../../containers/FindMerchant'
export const FindMerchantScreen: React.FC = () => {
    // ======================= VIEWS
    return (
        <>
            <SMFindMerchant />
        </>
    )
}

// ======================= EXPORT
export default FindMerchantScreen
